"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _item = _interopRequireDefault(require("./item.js"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/** Allows a user to create multiple tabs on a single page. */
var Tabs = /*#__PURE__*/function (_React$Component) {
  _inherits(Tabs, _React$Component);
  var _super = _createSuper(Tabs);
  function Tabs(props) {
    var _this;
    _classCallCheck(this, Tabs);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "_onSelectTab", function (tab) {
      if (_this.props.saveInHash) {
        window.location.hash = tab;
      }
      _this.setState({
        currentTab: tab
      });
      _this.props.onTabSelect(tab);
    });
    var _tab = props.initialTab || props.tabList[0].name;
    if (props.saveInHash) {
      if (window.location.hash !== '') {
        _tab = window.location.hash.substring(1);
      }
      window.location.hash = _tab;
    }
    _this.state = {
      currentTab: _tab
    };
    return _this;
  }
  _createClass(Tabs, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.saveInHash) {
        var newTab = window.location.hash && window.location.hash.substring(1) || '';
        if (newTab !== this.state.currentTab) {
          // eslint-disable-next-line react/no-did-update-set-state
          this.setState({
            currentTab: newTab
          });
          this.props.onTabSelect(newTab);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      if (this.props.tabList.length === 0) {
        return null;
      }
      var tabContent = '';
      var rows = this.props.tabList.map(function (item) {
        if (_this2.state.currentTab === item.name) {
          tabContent = item.content;
        }
        return /*#__PURE__*/_react["default"].createElement(_item["default"], {
          key: item.name,
          name: item.name,
          title: item.title,
          badge: item.badge,
          isActive: _this2.state.currentTab === item.name,
          onSelectTab: _this2._onSelectTab
        });
      });
      if (this.props.orientation === 'vertical') {
        var left = this.props.verticalTabWidths.left;
        var right = this.props.verticalTabWidths.right;
        if (left + right !== 12) {
          console.warn('Vertical tab widths do not add up to 12, using defaults...');
          left = 3;
          right = 9;
        }
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].vertical + ' row'
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "col-xs-".concat(left)
        }, /*#__PURE__*/_react["default"].createElement("ul", {
          className: 'nav nav-tabs ' + _style["default"].tabs + ' ' + _style["default"].tabsLeft
        }, rows)), /*#__PURE__*/_react["default"].createElement("div", {
          className: "col-xs-".concat(right)
        }, tabContent));
      }
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("ul", {
        className: 'nav nav-tabs ' + _style["default"].tabs
      }, rows), /*#__PURE__*/_react["default"].createElement("div", {
        className: "dash-wrapper"
      }, tabContent));
    }
  }]);
  return Tabs;
}(_react["default"].Component);
exports["default"] = Tabs;
_defineProperty(Tabs, "propTypes", {
  /** Array with the structure {name: ???, title: ???, content: ???} */
  tabList: _propTypes["default"].array,
  /** The name of the tab to start out on */
  initialTab: _propTypes["default"].string,
  /** Save the current tab in the URL hash or not? */
  saveInHash: _propTypes["default"].bool,
  /** Tab orientation (vertical or horizontal) */
  orientation: _propTypes["default"].string,
  /** Callback for what to do when a tab is selected */
  onTabSelect: _propTypes["default"].func,
  /** If orientation is vertical, you can pass the bootstrap grid widths of tab and content cols */
  verticalTabWidths: _propTypes["default"].object
});
_defineProperty(Tabs, "defaultProps", {
  tabList: [],
  initialTab: null,
  saveInHash: false,
  orientation: 'horizontal',
  onTabSelect: function onTabSelect() {},
  verticalTabWidths: {
    left: 3,
    right: 9
  }
});